'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var style = require('../../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-0"
})(["display:grid;grid-auto-flow:row;flex-direction:column;width:100%;grid-gap:32px;max-width:520px;justify-content:stretch;margin:0.5rem auto;"]);
const LocationItemWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-1"
})(["display:grid;grid-auto-flow:row;width:100%;grid-gap:8px;"]);
const PostalCodeUpdate = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-2"
})(["align-self:center;justify-self:center;", " font-weight:700;display:flex;gap:10px;align-items:center;flex-wrap:wrap;justify-content:center;"], _ref => {
  let {
    theme
  } = _ref;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const PostalCodeButton = styled__default["default"].button.withConfig({
  componentId: "sc-or6idy-3"
})(["border:0 none;text-decoration:underline;background:transparent;height:48px;cursor:pointer;", " @media (hover:hover){&:hover{", "}}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.linksNoneDefault;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.linksNoneHover;
});
const PostalCodeForm = styled__default["default"].form.withConfig({
  componentId: "sc-or6idy-4"
})(["display:inline-flex;gap:10px;align-items:center;flex-wrap:wrap;justify-content:center;"]);
const LocationSearcherWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-5"
})(["display:flex;justify-content:space-between;width:100%;max-width:520px;margin:auto;"]);
const SortByWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-6"
})(["align-self:center;justify-self:center;", " font-weight:700;display:flex;gap:10px;align-items:center;flex-wrap:wrap;justify-content:center;"], _ref4 => {
  let {
    theme
  } = _ref4;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const SortBySelect = styled__default["default"].select.withConfig({
  componentId: "sc-or6idy-7"
})(["border-width:0;text-decoration:underline;", " ", " @media (hover:hover){&:hover{", "}}"], _ref5 => {
  let {
    theme
  } = _ref5;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.linksNoneDefault;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.linksNoneHover;
});
const ChangePostalCodeWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-or6idy-8"
})(["margin:0.25rem auto;"]);

exports.ChangePostalCodeWrapper = ChangePostalCodeWrapper;
exports.LocationItemWrapper = LocationItemWrapper;
exports.LocationSearcherWrapper = LocationSearcherWrapper;
exports.PostalCodeButton = PostalCodeButton;
exports.PostalCodeForm = PostalCodeForm;
exports.PostalCodeUpdate = PostalCodeUpdate;
exports.SortBySelect = SortBySelect;
exports.SortByWrapper = SortByWrapper;
exports.Wrapper = Wrapper;
